import axios from '@/http/index';

const base = '';
export default {
  // (5.2)套餐划扣详情
  getVipCardAnalyse(params) {
    return axios.get(`${base}/erp/analyse/getVipCardAnalyse`, params).then((res) => res.data);
  },
  // (5.2)套餐概况
  getVipCardSaleAndDeductMsg(params) {
    return axios.get(`${base}/erp/analyse/getVipCardSaleAndDeductMsg`, params).then((res) => res.data);
  },
  // (5.2)套餐销售(上面的总数量)
  getVipCardSaleDetailMsg(params) {
    return axios.get(`${base}/erp/analyse/getVipCardSaleDetailMsg`, params).then((res) => res.data);
  },
  // (5.2)套餐销售（下面的分页数量）
  getVipCardSaleDetailPage(params) {
    return axios.get(`${base}/erp/analyse/getVipCardSaleDetailPage`, params).then((res) => res.data);
  },
  // 5.2导出套餐划扣
  exportVipCardDeduct(params) {
    return axios.get(`${base}/erp/analyse/exportVipCardDeduct`, params).then((res) => res.data);
  },
  // （5.2）导出套餐销售（下面的分页数量）
  exportVipCardSaleDetailPage(params) {
    return axios.get(`${base}/erp/analyse/exportVipCardSaleDetailPage`, params).then((res) => res.data);
  },
  // 5.9套餐划扣页面
  getVipCardsDeduct(params) {
    return axios.get(`${base}/erp/analyse/getVipCardsDeduct`, params).then((res) => res.data);
  },
  // 5.10-销售分析-项目分析
  getItemAnalyseMsg(params) {
    return axios.get(`${base}/erp/saleStatistics/getItemAnalyseMsg`, params).then((res) => res.data);
  },
  // 5.10销售分析-产品分析
  getProductAnalyseMsg(params) {
    return axios.get(`${base}/erp/saleStatistics/getProductAnalyseMsg`, params).then((res) => res.data);
  },
  // 5.10销售分析-员工销售分析
  getTechnicianSaleAnalyseMsg(params) {
    return axios.get(`${base}/erp/saleStatistics/getTechnicianSaleAnalyseMsg`, params).then((res) => res.data);
  },
  // 5.10销售分析-员工劳动分析
  getTechnicianServeAnalyseMsg(params) {
    return axios.get(`${base}/erp/saleStatistics/getTechnicianServeAnalyseMsg`, params).then((res) => res.data);
  },
  // 6.10 赠品统计
  getGiftStatistics(params) {
    return axios.get(`${base}/erp/saleStatistics/getGiftStatistics`, params).then((res) => res.data);
  },
};
